export default __webpack_public_path__ + "static/Findlay-013cde7059a53d262916a9e859b92117.svg";